export default "__VITE_ASSET__ccf71916__"